<template>
  <v-container>
    <nav class="navbar navbar-inverse navbar-fixed-top style">
      <div class="container-fluid col-sm-12 col-md-12 col-xs-12 col-xl-12">
        <div class="navbar-header">
          <v-btn class="hidden-md-and-up button-personal" icon @click="changeButton()">
            <v-icon>list</v-icon>
          </v-btn>
          <img :src="img1" height="55" width="200" />
        </div>
        <ul class="nav navbar-nav navbar-right hidden-sm-and-down">
          <v-chip color="#f1f1f1" text-color="#ec6a12">
            {{this.$session.getAll().ccData.ccNombre}}
            <v-icon color="white" right>account_balance</v-icon>
          </v-chip>
          <img :src="img2" height="55" width="70" />
        </ul>
      </div>
    </nav>
    <v-layout row>
      <v-flex md2 lg2 sm0 xs0>
        <v-navigation-drawer v-if="mini" stateless touchless value="true" fixed>
          <v-list>
            <v-list-tile>
              <v-list-tile-action>
                <v-icon>home</v-icon>
              </v-list-tile-action>
              <v-list-tile-title>Gestión 2030</v-list-tile-title>
            </v-list-tile>

            <v-list-tile v-if="this.$session.getAll().userType == 'dge'" :to="{name:'dgecc'}">
              <v-list-tile-title>Archivos DGE</v-list-tile-title>
            </v-list-tile>
            <v-list-tile v-if="this.$session.getAll().userType == 'dge'" :to="{name:'ccm'}">
              <v-list-tile-title>Cambiar Centro Costo</v-list-tile-title>
            </v-list-tile>
            <v-list-tile v-if="this.$session.getAll().userType == 'dge'" :to="{name:'vicerrectorias'}">
              <v-list-tile-title>Cambiar Vicerrectoría</v-list-tile-title>
            </v-list-tile>

            <v-list-group value="true">
              <template v-slot:activator>
                <v-list-tile @click="redirect('intro')">
                  <v-list-tile-title>PEI 2030</v-list-tile-title>
                </v-list-tile>
              </template>
              <v-list-group no-action sub-group>
                <template v-slot:activator>
                  <v-list-tile :to="{name:'video'}">
                    <v-list-tile-title>Diagnóstico Estratégico</v-list-tile-title>
                  </v-list-tile>
                </template>

                <v-list-tile :to="{name:'institucional'}" active-class="fix-position">
                  <v-list-tile-title v-text="'Institucional'"></v-list-tile-title>
                </v-list-tile>
                <v-list-tile
                  v-if="this.$session.getAll().userType != 'Vicerrector' && (this.$session.getAll().userType == 'dge' &&  this.$session.getAll().ccData.tipo != 'Vicerrectoria')"
                  :to="{name:'departamento'}"
                  active-class="fix-position"
                >
                  <v-list-tile-title v-text="'Departamento'"></v-list-tile-title>
                </v-list-tile>

                <v-list-tile :to="{name:'entorno'}" active-class="fix-position">
                  <v-list-tile-title v-text="'Prospectiva'"></v-list-tile-title>
                </v-list-tile>
              </v-list-group>
              <v-list-group no-action sub-group>
                <template v-slot:activator>
                  <v-list-tile :to="{name:'introDefinicion' }">
                    <v-list-tile-title>Definiciones Estratégicas</v-list-tile-title>
                  </v-list-tile>
                </template>
              </v-list-group>

              <v-list-group
                v-if="(this.$session.getAll().userType == 'Director' || this.$session.getAll().userType == 'dge'
                      || this.$session.getAll().userType == 'Vicerrector') && this.$session.getAll().ccData.ccValor!=0"
                no-action
                sub-group
              >
                <template v-slot:activator>
                  <v-list-tile>
                    <v-list-tile-title>Planes de Desarrollo</v-list-tile-title>
                  </v-list-tile>
                </template>

                <v-list-tile
                  v-if="this.$session.getAll().userType == 'Director' || (this.$session.getAll().userType == 'dge' &&  this.$session.getAll().ccData.tipo != 'Vicerrectoria')"
                  :to="{name:'planes',params: { id: '2020' }}"
                  active-class="fix-position"
                >
                  <v-list-tile-title v-text="'Priorización de Planes'"></v-list-tile-title>
                </v-list-tile>

                <v-list-tile
                  v-if="(this.$session.getAll().userType == 'dge' &&  this.$session.getAll().ccData.tipo != 'Vicerrectoria')"
                  :to="{name:'planes',params: { id: '2021' }}"
                  active-class="fix-position"
                >
                  <v-list-tile-title v-text="'Priorización Planes 2021'"></v-list-tile-title>
                </v-list-tile>

                <v-list-tile
                  v-if="this.$session.getAll().userType == 'Vicerrector' || this.$session.getAll().ccData.tipo == 'Vicerrectoria'"
                  :to="{name:'taller'}"
                  active-class="fix-position"
                >
                  <v-list-tile-title v-text="'Seguimiento'"></v-list-tile-title>
                </v-list-tile>
              </v-list-group>

              <v-list-group
                no-action
                sub-group
                v-if="this.$session.getAll().userType == 'Director' || (this.$session.getAll().userType == 'dge' &&  this.$session.getAll().ccData.tipo != 'Vicerrectoria')"
              >
                <template v-slot:activator>
                  <v-list-tile>
                    <v-list-tile-title>Proyectos Operativos</v-list-tile-title>
                  </v-list-tile>
                </template>

                <v-list-tile
                  :to="{name:'seguimiento',params: { id: '2018' }}"
                  active-class="fix-position"
                >
                  <v-list-tile-title v-text="'2018'"></v-list-tile-title>
                </v-list-tile>

                <v-list-tile
                  :to="{name:'seguimiento',params: { id: '2019' }}"
                  active-class="fix-position"
                >
                  <v-list-tile-title v-text="'2019'"></v-list-tile-title>
                </v-list-tile>

                <v-list-tile
                  :to="{name:'estrategias',params: { id: '2020' }}"
                  active-class="fix-position"
                >
                  <v-list-tile-title v-text="'2020'"></v-list-tile-title>
                </v-list-tile>

                <!-- <v-list-tile
                  :to="{name:'estrategias',params: { id: '2021' }}"
                  active-class="fix-position"
                >
                  <v-list-tile-title v-text="'2021'"></v-list-tile-title>
                </v-list-tile> -->

                <v-list-tile
                  :to="{name:'planes2021'}"
                  active-class="fix-position"
                >
                  <v-list-tile-title v-text="'2021'"></v-list-tile-title>
                </v-list-tile>
              </v-list-group>
            </v-list-group>

            <v-list-tile @click="logout()">
              <v-list-tile-action>
                <v-icon>arrow_back</v-icon>
              </v-list-tile-action>
              <v-list-tile-title>Cerrar Sesión</v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-navigation-drawer>
      </v-flex>
      <!-- lado derecho del contenido -->
      <v-flex md10 lg10 xl10 sm12 xs12>
        <div class="container">
          <router-view></router-view>
        </div>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
//import Test from './Test'
//import Form from './Form'
//import Criterio from './Criterio'
import img1 from "../../assets/LOGO PLATAFORMA.png";
import img2 from "../../assets/LOGO 170.png";
export default {
  type: "",
  name: "Sidebar",
  props: ["data"],
  components: {
    //Test,
    //Form,
    //Criterio,
  },

  data() {
    return {
      alerta: "",
      dialog: false,
      mostrar: true,
      on: false,
      esMayor: "",
      drawer: true,
      drawerRight: true,
      right: true,
      left: null,
      test: "hidden-sm-and-down",
      img1: img1,
      img2: img2,
      admins: [
        ["Management", "people_outline"],
        ["Settings", "settings"]
      ],
      cruds: [
        ["Create", "add"],
        ["Read", "insert_drive_file"],
        ["Update", "update"],
        ["Delete", "delete"]
      ],
      mini: true,
      drawer: true,
      auth: {
        headers: { Authorization: "" + this.$session.get("jwt") }
      }
    };
  },

  created() {
    //console.log(process.env.ROOT_API);
    this.type = this.$session.getAll().userType;
    this.esMayor = this.$session.getAll().ccData.esMayor;

    axios
      .get(
        process.env.ROOT_API + "/uploadFileDcaEtc/getByCcValor?ccValor=0",
        this.auth
      )
      .then(response => {
        this.alert = response.data.alert;
        //console.log(response.data)
        if (this.alert != "") {
          alert(this.alert);
        }

        //console.log(this.filesDge);
      })
      .catch(error => {
        console.error(error);
      });
  },
  methods: {
    closeBar() {
      this.mini = false;
    },
    openBar() {
      this.mini = true;
    },
    changeButton() {
      //console.log("kjashdkjaHSDK");
      if (this.mini == false) {
        this.openBar();
      } else {
        this.closeBar();
      }
    },
    redirect(index) {
      this.$router.push({ name: index });
    },

    logout() {
      this.$session.destroy();
      this.$router.push("/");
    }
  }
};
</script>

<style >
.headline {
  text-align: center !important;
}
.v-navigation-drawer--fixed {
  padding-top: 70px;
  padding-bottom: 50px;
  display: block;
  left: 0;
  max-width: 250px !important;
  overflow-y: auto;
  overflow-x: hidden;
  pointer-events: auto;
  top: 0;
  will-change: transform;
  z-index: 3;
  transition-delay: 2s;
}

.container-pro {
  align-items: left;
  margin-top: 70px;
  padding-bottom: 50px;
  left: 0;
  z-index: 6;
  position: fixed;
}

.button-personal {
  align-self: left;
}

.theme--light.v-navigation-drawer {
  background-color: #394049 !important;
}

.v-list__group__header--active .v-list__group__header__prepend-icon .v-icon {
  color: #ec6a12 !important;
}

.v-list__tile__title {
  color: #f1f1f1 !important;
}

.theme--light.v-icon {
  color: #ec6a12 !important;
}

.primary {
  background-color: #273039 !important;
}

.style {
  background: white !important;
  border-top: 3px solid #eb7704 !important;
  border-bottom: 7px solid #b1b1b1 !important;
  height: 70px;
}

.img-style {
  text-align: right;
}

.fix-position {
  background: #ec6a12;
  text-decoration-line: none !important;
  text-decoration: none !important;
}

.pading-group {
  padding-left: 25px !important;
}
</style>






// WEBPACK FOOTER //
// src/components/template/SideBar.vue